import _ from "lodash";
import { Event } from "../types/event";
import Utils from "../common/utils";

const table_events = [
    {
      "prefecture": 16,
      "eventId": 27,
      "category": 3,
      "title": "初夏の大北海道展",
      "place": "富山大和6Fホール",
      "geometry": {
        "type": "Point",
        "coordinates": [
          137.212966909528,
          36.6893524932771
        ]
      },
      "description": "北海道のグルメ、名産品、銘菓、スイーツなどが大集合！お肉や海鮮のお弁当、いちごを使ったスイーツ、ラーメン茶屋（実演販売）など。",
      "image": "16-27",
      "url": "https://www.daiwa-dp.co.jp/toyama/2025/04/-1.php",
      "startDate": "2025-04-23",
      "endDate": "2025-04-29",
      "startTime": "10:00",
      "endTime": "19:00"
    },
    {
      "prefecture": 16,
      "eventId": 28,
      "category": 6,
      "title": "コラーレ de フリーマーケット",
      "place": "黒部市国際文化センター コラーレ",
      "geometry": {
        "type": "Point",
        "coordinates": [
          137.452632952235,
          36.8796267939278
        ]
      },
      "description": "県内最大級!80店が大集合! 日用雑貨からおいしい食べ物まで、いろんなお店が大集合！あなたのお目当ての品がきっとみつかるはず。",
      "image": "16-28",
      "url": "https://www.colare.jp/utage/11855/",
      "startDate": "2025-04-29",
      "endDate": "2025-04-29",
      "startTime": "10:00",
      "endTime": "14:00"
    },
    {
      "prefecture": 16,
      "eventId": 29,
      "category": 1,
      "title": "石動曳山祭",
      "place": "石動市街地・小矢部市民交流プラザ前お祭り広場",
      "geometry": {
        "type": "Point",
        "coordinates": [
          136.86659102047,
          36.6783886632232
        ]
      },
      "description": "11基の豪華絢爛な山車が巡行します。13:30〜花山車勢揃い、19:40〜提灯山車ライトアップ。",
      "image": "16-29",
      "url": "https://oyabe.info/2869/",
      "startDate": "2025-04-29",
      "endDate": "2025-04-29",
      "startTime": "13:30",
      "endTime": "20:30"
    },
    {
      "prefecture": 16,
      "eventId": 19,
      "category": 1,
      "title": "出町子供歌舞伎曳山祭",
      "place": "砺波市出町子供歌舞伎曳山会館",
      "geometry": {
        "type": "Point",
        "coordinates": [
          136.95649287000026,
          36.64109102045667
        ]
      },
      "description": "子供歌舞伎上演中の子供役者の移動はすべて肩車で行われ、地面に足をつけさせないことになっています。これは、神明宮でお祓いを受けることにより、神の依代とされた古い神意を伝えています。",
      "image": "16-19",
      "url": "http://www.tonami-cci.jp/hikiyama/",
      "startDate": "2025-04-29",
      "endDate": "2025-04-30",
      "startTime": "10:00",
      "endTime": "21:00"
    },
    {
      "prefecture": 16,
      "eventId": 15,
      "category": 1,
      "title": "高岡御車山祭",
      "place": "山町一帯、片原町周辺",
      "geometry": {
        "type": "Point",
        "coordinates": [
          137.01213127444723,
          36.74598431724929
        ]
      },
      "description": "高岡の金工、漆工などの優れた工芸技術の装飾が施された7基の御車山が、旧市街中心部をゆっくりと巡行します。4月30日には宵祭があり、御車山のライトアップが行われます。",
      "image": "16-15",
      "url": "https://www.mikurumayama.jp/",
      "startDate": "2025-05-01",
      "endDate": "2025-05-01",
      "startTime": "11:00",
      "endTime": "18:00"
    },
    {
      "prefecture": 16,
      "eventId": 30,
      "category": 1,
      "title": "福野夜高祭",
      "place": "福野中心市街地",
      "geometry": {
        "type": "Point",
        "coordinates": [
          136.923153009867,
          36.5889526207902
        ]
      },
      "description": "1日・2日は行燈の練り廻しが催されます。1日はコンクール、2日は23:00頃～は行燈を壊し合う引合い（喧嘩）が行われます。3日の本祭りでは曳山が町内を巡行します。",
      "image": "16-30",
      "url": "https://www.tabi-nanto.jp/fukuno_yotaka/",
      "startDate": "2025-05-01",
      "endDate": "2025-05-01",
      "startTime": "18:30",
      "endTime": "23:00"
    },
    {
      "prefecture": 16,
      "eventId": 32,
      "category": 4,
      "title": "とやま駅ナカ酒BAR",
      "place": "富山駅南北自由通路",
      "geometry": {
        "type": "Point",
        "coordinates": [
          137.213902668887,
          36.701754297361
        ]
      },
      "description": "富山の地酒を1杯250円、2杯で400円で楽しめます。マルート、とやマルシェのおつまみとともに。",
      "image": "16-32",
      "url": "https://toyama-stationcity.jp/event/detail.php?id=25000",
      "startDate": "2025-05-02",
      "endDate": "2025-05-02",
      "startTime": "15:00",
      "endTime": "20:00"
    },
    {
      "prefecture": 16,
      "eventId": 16,
      "category": 1,
      "title": "越中八尾 曳山祭",
      "place": "八尾町旧町内",
      "geometry": {
        "type": "Point",
        "coordinates": [
          137.1409101699986,
          36.58175439453031
        ]
      },
      "description": "彫刻、彫金、漆工芸など、越中美術工芸界の巨匠の作が惜しげもなく飾られた6本の曳山が、三味線、笛、太鼓の奏でる古式ゆかしい雅な曳山囃子とともに、揃いの法被姿の凛々しい若者らの手により引き回されます。夜には、数千もの灯がともる堤灯山となり、夜景に浮き上がるように照らされて坂の町を登る光景は、あたかも不夜城のごとく豪華かつ幻想的で、祭りは最高潮に達します。",
      "image": "16-16",
      "url": "https://www.yatsuo.net/",
      "startDate": "2025-05-03",
      "endDate": "2025-05-03",
      "startTime": "09:30",
      "endTime": "19:30"
    },
    {
      "prefecture": 16,
      "eventId": 23,
      "category": 2,
      "title": "大カターレDAY",
      "place": "マルート前広場",
      "geometry": {
        "type": "Point",
        "coordinates": [
          137.212714228334,
          36.7013497165661
        ]
      },
      "description": "ライカくんも登場しスタジアムグルメを始めとしたキッチンカーの出店、ダンスパフォーマンスやライカくんのふわふわ、その他にも様々なコンテンツを実施いたします。さらに、富山ステーションフロントCiC前で「ケーブルテレビ富山presents カターレ富山パブリックビューイング」も同時開催します。",
      "image": "16-23",
      "url": "https://toyama-stationcity.jp/event/detail.php?id=24875",
      "startDate": "2025-05-03",
      "endDate": "2025-05-03",
      "startTime": "11:00",
      "endTime": "16:00"
    },
    {
      "prefecture": 16,
      "eventId": 34,
      "category": 1,
      "title": "井波よいやさ祭り",
      "place": "井波中心市街地",
      "geometry": {
        "type": "Point",
        "coordinates": [
          136.975544761793,
          36.5593544368897
        ]
      },
      "description": "5月2日は宵祭り、3日は本祭りが行われます。獅子舞演舞、神輿巡行、屋体巡行。",
      "image": "16-34",
      "url": "https://www.tabi-nanto.jp/archives/14337",
      "startDate": "2025-05-03",
      "endDate": "2025-05-03",
      "startTime": "08:50",
      "endTime": "18:30"
    },
    {
      "prefecture": 16,
      "eventId": 35,
      "category": 6,
      "title": "春の太閤山フェスティバル",
      "place": "太閤山ランド 野外劇場周辺",
      "geometry": {
        "type": "Point",
        "coordinates": [
          137.105786941362,
          36.6953595928549
        ]
      },
      "description": "おしりたんていショー、ファンダービー、ニュースポーツ体験、カブトムシの幼虫配布、キッチンカー営業などが催されます。",
      "image": "16-35",
      "url": "https://www.toyamap.or.jp/taikou-land/gw/",
      "startDate": "2025-05-03",
      "endDate": "2025-05-03",
      "startTime": "10:00",
      "endTime": "16:00"
    },
    {
      "prefecture": 16,
      "eventId": 36,
      "category": 1,
      "title": "たかまちまつり",
      "place": "高岡市中心商店街",
      "geometry": {
        "type": "Point",
        "coordinates": [
          137.01525479884,
          36.7426530298906
        ]
      },
      "description": "高岡市3団体、射水市1団体、高岡市内の保育園2団体による獅子舞が催されます。台湾獅子の披露や、獅子マルシェも。",
      "image": "16-36",
      "url": "https://www.takaoka-st.jp/events/23101/",
      "startDate": "2025-05-03",
      "endDate": "2025-05-03",
      "startTime": "13:00",
      "endTime": "20:00"
    },
    {
      "prefecture": 16,
      "eventId": 24,
      "category": 5,
      "title": "TSCこいのぼり大作戦!!",
      "place": "マルート前広場",
      "geometry": {
        "type": "Point",
        "coordinates": [
          137.212714228334,
          36.7013497165661
        ]
      },
      "description": "ごっこぱーくではゴールデンウィーク前から、「こいのぼり」がいっぱい泳ぎます。2025年5月4日（日）は、合言葉を言った先着50名さまに「シャボン玉セット」をプレゼントします。タイミングが合えば、ごっこぱーくに巨大シャボン玉が出現するかも…　ぜひ、合言葉を探してから遊びに来てください",
      "image": "16-24",
      "url": "https://toyama-stationcity.jp/event/detail.php?id=24875",
      "startDate": "2025-05-04",
      "endDate": "2025-05-04",
      "startTime": "10:00",
      "endTime": "16:00"
    },
    {
      "prefecture": 16,
      "eventId": 10,
      "category": 6,
      "title": "となみチューリップフェア",
      "place": "砺波チューリップ公園",
      "geometry": {
        "type": "Point",
        "coordinates": [
          136.96204722593825,
          36.64028937792237
        ]
      },
      "description": "300品種300万本のチューリップが咲き誇ります！チューリップタワーからの大花壇、「花の大谷」、「水上花壇」など見どころ多数。様々なステージイベントやグルメ販売も。入場料は大人（高校生以上） 一般1,500円（前売り1,400円）、小人（小・中学生） 一般200円、小学生未満無料。",
      "image": "16-10",
      "url": "https://fair.tulipfair.or.jp/",
      "startDate": "2025-04-22",
      "endDate": "2025-05-05",
      "startTime": "09:00",
      "endTime": "17:30"
    },
    {
      "prefecture": 16,
      "eventId": 25,
      "category": 5,
      "title": "TSCキッズフェス",
      "place": "マルート前広場",
      "geometry": {
        "type": "Point",
        "coordinates": [
          137.212714228334,
          36.7013497165661
        ]
      },
      "description": "簡単！画用紙を使ってオリジナルのこいのぼりバッグをつくります。こいのぼりバッグを持って対象箇所をまわるとお菓子がもらえます。身の回りのものを使った昔ながらのおもちゃ作り（クリアファイルを使ったかざぐるま、牛乳パックを使ったブンブンごま、紙皿を使ったでんでんだいこ）を行います。その他、体を動かして遊べる、手作りすべり台や皿回し、段ボール遊びもございます。",
      "image": "16-25",
      "url": "https://toyama-stationcity.jp/event/detail.php?id=24875",
      "startDate": "2025-05-05",
      "endDate": "2025-05-05",
      "startTime": "11:00",
      "endTime": "14:00"
    },
    {
      "prefecture": 16,
      "eventId": 26,
      "category": 6,
      "title": "瑞龍寺 ライトアップ",
      "place": "国宝 高岡山瑞龍寺",
      "geometry": {
        "type": "Point",
        "coordinates": [
          137.010562440588,
          36.7357760328776
        ]
      },
      "description": "瑞龍寺がライトアップなどの光と幻想的な音楽に包まれます。ジャイアントフラワーの展示、行灯による演出なども。夜間拝観券（運営協力費）1,000円※中学生以下無料。",
      "image": "16-26",
      "url": "https://zuiryuji-lightup.com/",
      "startDate": "2025-04-22",
      "endDate": "2025-05-05",
      "startTime": "18:00",
      "endTime": "21:00"
    },
    {
      "prefecture": 16,
      "eventId": 33,
      "category": 4,
      "title": "とやま駅ナカ酒BAR",
      "place": "富山駅南北自由通路",
      "geometry": {
        "type": "Point",
        "coordinates": [
          137.213902668887,
          36.701754297361
        ]
      },
      "description": "富山の地酒を1杯250円、2杯で400円で楽しめます。マルート、とやマルシェのおつまみとともに。",
      "image": "16-33",
      "url": "https://toyama-stationcity.jp/event/detail.php?id=25000",
      "startDate": "2025-05-05",
      "endDate": "2025-05-05",
      "startTime": "15:00",
      "endTime": "20:00"
    },
    {
      "prefecture": 16,
      "eventId": 37,
      "category": 3,
      "title": " HOKURIKU パンフェス",
      "place": "三井アウトレットパーク北陸小矢部",
      "geometry": {
        "type": "Point",
        "coordinates": [
          136.882317994103,
          36.6889302175266
        ]
      },
      "description": "富山、石川を中心に、人気のパン店が集まります。",
      "image": "16-37",
      "url": "https://takt-toyama.net/?tid=105383",
      "startDate": "2025-05-03",
      "endDate": "2025-05-05",
      "startTime": "09:30",
      "endTime": "16:00"
    },
    {
      "prefecture": 16,
      "eventId": 14,
      "category": 5,
      "title": "アスレチック広場",
      "place": "グランドプラザ",
      "geometry": {
        "type": "Point",
        "coordinates": [
          137.21374345491986,
          36.68954803825182
        ]
      },
      "description": "天候を気にせず楽しめる子どもの遊び場です。すべり台ブランコなど4種類のアスレチック遊具のほか、自力でこぐゴーカートや、乳幼児と保護者が遊べる遊具など、さまざまな遊具を設置します。(火曜日休み・最終受付16:30)3歳未満無料・3歳から小学生700円・保護者同伴300円",
      "image": "16-14",
      "url": "https://www.siminplaza.co.jp/grandplaza/?tid=205661",
      "startDate": "2025-04-26",
      "endDate": "2025-05-06",
      "startTime": "13:00",
      "endTime": "17:00"
    },
    {
      "prefecture": 16,
      "eventId": 31,
      "category": 3,
      "title": "初夏の大北海道展",
      "place": "富山大和6Fホール",
      "geometry": {
        "type": "Point",
        "coordinates": [
          137.212966909528,
          36.6893524932771
        ]
      },
      "description": "北海道のグルメ、名産品、銘菓、スイーツなどが大集合！お肉や海鮮のお弁当、いちごを使ったスイーツ、ラーメン茶屋（実演販売）など。",
      "image": "16-31",
      "url": "https://www.daiwa-dp.co.jp/toyama/2025/04/post-2390.php",
      "startDate": "2025-05-01",
      "endDate": "2025-05-06",
      "startTime": "10:00",
      "endTime": "19:00"
    },
    {
      "prefecture": 16,
      "eventId": 38,
      "category": 5,
      "title": "ちびっ子天国 in 海王丸パーク",
      "place": "海王丸パーク",
      "geometry": {
        "type": "Point",
        "coordinates": [
          137.10764783877,
          36.781037048025
        ]
      },
      "description": "両日：ちびっこミニ遊園地、カーニバルゲーム、キッチンカー、フリーマーケット、親子工作教室などが催されます。5日（月）は海王丸の総帆展帆、6日（火）はクラシックカーファンタジーなども。",
      "image": "16-38",
      "url": "http://www.kaiwomaru.jp/newsinfo/gw%e3%82%a4%e3%83%99%e3%83%b3%e3%83%88%e3%80%8c%e3%81%a1%e3%81%b3%e3%81%a3%e5%ad%90%e5%a4%a9%e5%9b%bd-in-%e6%b5%b7%e7%8e%8b%e4%b8%b8%e3%83%91%e3%83%bc%e3%82%af2025%e3%80%8d%e3%81%ae%e9%96%8b%e5%82%ac/",
      "startDate": "2025-05-05",
      "endDate": "2025-05-06",
      "startTime": "10:00",
      "endTime": "16:00"
    },
    {
      "prefecture": 16,
      "eventId": 21,
      "category": 6,
      "title": "富山城 プロジェクションマッピング",
      "place": "富山城址公園",
      "geometry": {
        "type": "Point",
        "coordinates": [
          137.21161048640792,
          36.69273894839771
        ]
      },
      "description": "富山市のシンボルで国登録有形文化財・富山城（富山市郷土博物館）に、鳳凰や富山の伝統工芸、富山県の県花・チューリップなどをモチーフとしたデジタルアートによるプロジェクションマッピング映像を投影します。",
      "image": "16-21",
      "url": "https://prtimes.jp/main/html/rd/p/000000311.000046440.html",
      "startDate": "2025-05-24",
      "endDate": "2025-05-25",
      "startTime": "19:30",
      "endTime": "21:30"
    },
    {
      "prefecture": 16,
      "eventId": 17,
      "category": 1,
      "title": "津沢夜高あんどん祭",
      "place": "富山県小矢部市　津沢市街地、あんどん広場",
      "geometry": {
        "type": "Point",
        "coordinates": [
          136.8966923824972,
          36.623752972552566
        ]
      },
      "description": "大行燈は、田楽、山車、釣りものから組み立てられた雄大なもので、宵闇が迫る頃、灯りがつけられた色鮮やかな大行燈が、太鼓の響きとともにメインストリートを練り歩きます。祭のメインイベントである「喧嘩夜高行燈引き廻し」では、向かい合った2つの大行燈が、掛け声を合図に激しくぶつかり合うシーンが見どころです。大行燈がぶつかり合う瞬間に、観客の歓声も響きわたり、祭を大いに盛り上げます。",
      "image": "16-17",
      "url": "https://www.oyabe.info/archives/tour/tsuzawa-yotaka/",
      "startDate": "2025-06-06",
      "endDate": "2025-06-07",
      "startTime": "18:00",
      "endTime": "00:00"
    },
    {
      "prefecture": 16,
      "eventId": 12,
      "category": 6,
      "title": "雪の大谷フェスティバル",
      "place": "雪の大谷",
      "geometry": {
        "type": "Point",
        "coordinates": [
          137.5915506389552,
          36.576839160169996
        ]
      },
      "description": "「雪の大谷ウォーク」では、雪の壁に挟まれた道の片側を歩行者用通路として開放された場所を歩くことができます。間近で見る雪の壁は想像以上の迫力！ 雪の白と青空のコントラストに清々しさを覚えます。",
      "image": "16-12",
      "url": "https://www.info-toyama.com/events/30003",
      "startDate": "2025-04-15",
      "endDate": "2025-06-25",
      "startTime": "09:30",
      "endTime": "15:00"
    }
  ]

const _promise = {
    resolve: (args: any) => {
        console.log(args);
        return Promise.resolve(args);
    },
    reject: (args: any) => {
        console.log(args);
        return Promise.reject(args);
    }
};

const EVENTS_LIST = (param: any) => {

    // 本日より後のイベントのみに絞り込み
    const filterData = _.filter(table_events, (data: Event) => {
        return Utils.beforeEvent(data.endDate);
    });

    const body = filterData;

    const data = {
        body
    }

    return _promise.resolve({ data });
}

export default {
    EVENTS_LIST
}